/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';
import { Flex } from 'pcln-design-system';
import { Bed as BedIcon, Cars as CarsIcon, Cruises as CruisesIcon, Flights as FlightsIcon, Luggage as LuggageIcon } from 'pcln-icons';
import { CAR, CRUISE, FLIGHT, HOTEL, PACKAGE } from '../constants/productIcons';
const DEFAULT_ICON_SIZE = '40px';
const RoundFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ProductIcon__RoundFlex",
  componentId: "sc-xrhq1j-0"
})(["border-radius:50%;flex-shrink:0;"]);
function getIcon(type) {
  const props = {
    color: 'primary',
    ['data-testid']: 'product-icon-id'
  };
  switch (type) {
    case PACKAGE:
      return React.createElement(LuggageIcon, {
        ...props
      });
    case HOTEL:
      return React.createElement(BedIcon, {
        ...props
      });
    case FLIGHT:
      return React.createElement(FlightsIcon, {
        ...props
      });
    case CAR:
      return React.createElement(CarsIcon, {
        ...props
      });
    case CRUISE:
      return React.createElement(CruisesIcon, {
        ...props
      });
  }
}
/** @public */
function ProductIcon({
  alignItems = 'center',
  backgroundColor = 'background.lightest',
  type,
  height = DEFAULT_ICON_SIZE,
  justifyContent = 'center',
  width = DEFAULT_ICON_SIZE,
  ...props
}) {
  return React.createElement(RoundFlex, {
    alignItems: alignItems,
    color: backgroundColor,
    height: height,
    justifyContent: justifyContent,
    width: width,
    ...props
  }, getIcon(type));
}
export default ProductIcon;